<template>
  <transition name="modal">
    <div class="modal-mask ">
      <div class="modal-wrapper">
        <!-- <span>default footer</span> -->

        <div class="modal-container">
          <button style="margin-bottom: 30px;    float: left;
"
            class="modal-default-button btn btn-block btn-primary"
            @click="$emit('btnClose')"
          >
            بستن
          </button>

          <p v-html="htmldata"></p>
          <button style="margin-bottom: 30px;    float: left;"
            class="modal-default-button btn btn-block btn-primary"
            @click="$emit('btnPrint')"
          >
            print
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import store from "../../../../views/profile/store/index";
export default {
  name: "PdkNumber",
  store,
  data: function () {
    return {
      htmldata: "",
    };
  },
  props: {
    reserveId: Number,
  },

  mounted: function () {
    this.getHtmlReserveData();
  },
  methods: {
    getHtmlReserveData() {
      this.$store
        .dispatch("getHotelCrsBookingVoucher", {
          reserveId: this.reserveId,
          sourceId: localStorage.getItem("SourceIdInReport"),
        })
        .then((res) => {
          this.htmldata = res.voucher;
        });
    },
  },
};
</script>

<style lang="css" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: auto;
  left:-200px;
  min-height: 500px;
  width: 100%;
  /* background-color: rgb(0 0 0 / 39%); */
  display: table;
  transition: opacity 0.3s ease;
  overflow-y: hidden;  
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.custom-footer {
  padding: 18px 5px 2px 5px !important;
}
.modal-container {
  width: 800px;
  margin: 0px auto;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  overflow-y: scroll; 
    min-height: 500px; 

    height: 800px; 
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0px 10px;
}

.modal-default-button {
  float: right;
  width: auto !important;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>